import { Component, input, OnInit, output } from '@angular/core';
import { GroupedCategory } from 'src/app/models/request-service.model';

@Component({
  selector: 'app-support-topics-card',
  templateUrl: './support-topics-card.component.html',
  styleUrls: ['./support-topics-card.component.scss'],
  standalone: false
})
export class SupportTopicsCardComponent {

  item = input<GroupedCategory>();
  title = input<string>();
  description = input<string>();
  emitCatalogId = output<number | null>();
  headerClick = output<void>();

  /**
   * Emits selected catalog id to parent component when a service item is clicked.
   */
  getServiceCatalog(catalogId: number | null) {
    this.emitCatalogId.emit(catalogId);
  }

  /**
   * Emits header click event to notify parent for navigation/back handling.
   */
  emitHeaderClick() {
    this.headerClick.emit();
  }

}